var RoutedView = (function (Backbone, DisplayRouter) {
	return Backbone.View.extend({
		_displayRouter: new DisplayRouter(),

		display: function (type, data) {
			this._displayRouter.display(type, data);
		},

		getPrevState: function () {
			return this._displayRouter.getHistoryPrev();
		},

		getCurrentState: function () {
			return this._displayRouter.getHistoryCurrent();
		}
	});
})(Backbone, DisplayRouter);